// extracted by mini-css-extract-plugin
export default {"searchWrapper":"SearchInput_searchWrapper__84srF","searchInp":"SearchInput_searchInp__Xia98","searchIcon":"SearchInput_searchIcon__uH+b0"};